import { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { updateHeader } from "../../slices/header-slice";
import { updateFaqsData } from "../../slices/app-slice";
import { getFaqs } from "../../api";
import { useDataLoading } from "../../hooks/useDataLoading";
import Animate from '../../components/animate';

import './styles.scss';
import Accordion from "../../components/accordion";

const FAQs = () => {
    const dispatch = useDispatch();
    const faqs = useSelector((state) => state.app.faqs);
    const [isFaqsLoading, setIsFaqsLoading] = useState(false);
    const hasFetched = useRef(false);

    useDataLoading('faqs', isFaqsLoading, []);

    useEffect(() => {
        const fetchFaqsData = async () => {
            const hasData = faqs && Array.isArray(faqs) && faqs.length > 0;

            if (!hasData && !hasFetched.current) {
                hasFetched.current = true;
                setIsFaqsLoading(true);
                try {
                    const response = await getFaqs();
                    dispatch(updateFaqsData(response.data));
                } catch (error) {
                    console.error('Error fetching FAQs data:', error);
                } finally {
                    setIsFaqsLoading(false);
                }
            }
        };

        fetchFaqsData();
    }, [faqs, dispatch]);

    useEffect(() => {
        dispatch(updateHeader('light'))
    }, [dispatch]);

    return (
        <div className="faqs">
            <h1>FAQ</h1>

            <Animate>
                <div className="content">
                    {faqs && faqs.map((faq) => (
                        <>
                            <h2>{faq.section}</h2>
                            <Accordion data={faq.content} />
                        </>
                    ))}
                </div>
            </Animate>


        </div>
    )
}

export default FAQs